import React from "react";
import FormField from '../../../FormField';

const ServiceType = ({ types }) => {
  const handleType = () => {
    console.log('')
  }
  return (
    <FormField label="Service Type" id="asset_type">
      <select id="asset_type" onChange={handleType}>
        {
          types.map((type, index) => (
            <option value={type.id} key={index}>{type.label}</option>
          ))
        }        
      </select>
    </FormField>
  );
};

export default ServiceType;
